import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'
import getSavedState from '../../utils/get-state'

export const state = {
  userData: {},
  cached: [],
  currentUser: getSavedState('auth.currentUser'),
}

export const getters = {
  UserObj: (state) => {
    return state.newUser
  },
  USERID: (state) => {
    return state.newUserID
  },
}

export const mutations = {
  CACHE_USER(state, newUser) {
    state.cached.push(newUser)
  },
  SET_UserDetails(state, newUser) {
    state.UserObj = newUser
  },
  SET_USER_ID(state, newUserID) {
    state.USERID = newUserID
  },
}

export const actions = {
  init({ state, dispatch }) {
    // setDefaultAuthHeaders(state)
  },
  updateStore({ commit }, { userInfo } = {}) {
    // authObj.actions.updateUserInfo({commit},{userInfor:userInfo})
    commit('auth/SET_CURRENT_USERINFO', userInfo, {
      root: true,
    })
  },
  storeUser({ commit }, { userDetails } = {}) {
    commit('SET_USER_ID', userDetails)
  },

  fetchCustomer({ state }, { pageNumber, pageSize } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getcustomers
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&isActive=1&CustomerType="External"`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchCustomersUserId(
    // eslint-disable-next-line no-empty-pattern
    { state }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getcustomersbyuserid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  searchCustomersByUserId({ commit }, { searchvalue } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.searchcustomersbyuserid
        }/${searchvalue}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchSuffixOption({ commit }) {
    return axios
      .get(`${appConfig.adminApiUri}master/getsuffixes`, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response.data
      })
    // .catch(function (error) {
    //   alert(error)
    // })
  },

  fetchRoleOption({ commit }, { role, customerId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getrolesbyrole
        }/${role}/${customerId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
    // .catch(function (error) {
    //   alert(error)
    // })
  },
  fetchCustomerApiScopes({ state }, { customerId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getCustomerPermissions
        }/${customerId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch(function(error) {
        alert(error)
      })
  },
  fetchProductsApiScopes({ commit }, { customerId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getProductsApiScopes}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
    // .catch(function (error) {
    //   alert(error)
    // })
  },
  fetchAMSCompanies({ commit }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getAMSCompanies
        }?Key=&Value=&SortBy=Name&SortDirection=Ascending`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
  },
  fetchUserRolesOption({ commit }) {
    return axios
      .get(`${appConfig.adminApiUri}master/getuserroles/1`, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response.data
      })
    // .catch((error) => {
    //   alert(error)
    // })
  },
  // Check User Name Exists or Not
  isUserNameExists({ commit }, { username } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.isusernameexists
        }/${username}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response.data
      })
  },
  // Create new user
  createNewUser({ commit }, { createUser }) {
    // console.log(requestString)
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.createUser}`,
        createUser,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response
      })
  },
  // Unlock user if user locked
  unlockUser({ commit }, { unlockuser }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.unlockuser}`,
        unlockuser,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  // Update existing user
  updateExistingUser({ commit }, { updateUser }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.updateUser}`,
        updateUser,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  fetchTotalUsers(
    { commit },
    { pageSize, pageNumber, customerId, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getuserstotalrecords
        }?PageSize=${pageSize}&PageNumber=${pageNumber}&customerId=${customerId}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response.data
      })
    // .catch(function(error) {
    //   // alert(error)
    // })
  },
  // eslint-disable-next-line no-empty-pattern
  fetchUsers(
    { commit },
    { pageSize, pageNumber, customerId, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getusers
        }?PageSize=${pageSize}&PageNumber=${pageNumber}&SelectedCustomer=${customerId}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
    // .catch(function(error) {
    //   // alert(error)
    // })
  },

  fetchxactusUsers(
    { commit },
    { pageSize, pageNumber, customerId, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getusers
        }?PageSize=${pageSize}&PageNumber=${pageNumber}&SelectedCustomer=${customerId}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
    // .catch(function(error) {
    //   // alert(error)
    // })
  },

  fetchUserById({ commit }, { userId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getuserbyid
        }/${userId}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        commit('SET_UserDetails', response.data)
        return response.data
      })
    // .catch((error) => {
    //   // alert(error)
    // })
  },

  fetchUserForEdit({ commit }, { userId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getuserforedit
        }/${userId}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        commit('SET_UserDetails', response.data)
        return response.data
      })
    // .catch((error) => {
    //   // alert(error)
    // })
  },

  fetchAllSkills({ commit }) {
    return axios
      .get(`${appConfig.apiEndPoint}${endpoint.adminApiPath.getskils}`, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchAllPackagesCustomer({ state }, { customerId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusPath.getCustomerFPPackages
        }/${customerId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getIsFraudPlusCustomer({ state }, { customerId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusPath.isFraudplusCustomer
        }/${customerId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  updateprofile({ commit }, { myprofile }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.updateprofile}`,
        myprofile,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  validateuser({ commit }, { userId, password }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.identityApiPath.validateuserpassword
        }/${userId}/${password}`,

        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // download
  downloadUserReport({ commit }, { pageSize, pageNumber, key, value }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.download
        }?Pagesize=${pageSize}&PageNumber=${pageNumber}&key=${key}&value=${value}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = '\r\n' + response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'UserReport.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'UserReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }

        return response
      })
    //  .catch((error) => {
    //
    //    alert(error)
    //   })
  },
  //
  resendEmailToUsers({ commit }, { resenduser } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.resend}`,
        resenduser,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
    // .catch(function(error) {
    //    // alert(error)
    //  })
  },

  forceFileDownload(response) {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'UserReport.csv') // or any other extension
    document.body.appendChild(link)
    link.click()
  },

  getSecurityQuestions() {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getSecurityQuestions}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getUserSecurityQAByUserId({ commit }, { userId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getUserSecurityQAByUserId
        }/${userId}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response.data
      })
    // .catch((error) => {
    //   // alert(error)
    // })
  },
  verifyAnswers({ commit }, { qa }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.verifyAnswers}`,
        qa,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
  },

  generatePassword() {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.generatePassword}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  sendPasswordToEmail({ commit }, { passwordBody }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.sendPasswordEmail}`,
        passwordBody,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
  },
}

/* const headers = {
  'Accept-Version': 1,
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json; charset=utf-8',
} */

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
